var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Button } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
export default function LogoUploader(_a) {
    var logoData = _a.logoData, setLogoData = _a.setLogoData;
    var handleFileChange = function (event) {
        var _a;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            var imageUrl = URL.createObjectURL(file);
            setLogoData({ logoUrl: imageUrl, logoFile: file });
        }
    };
    return (_jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "subtitle1", fontWeight: "bold" }, { children: "Logo" })), _jsx(Typography, __assign({ variant: "body2", color: "textSecondary" }, { children: "Esta imagen ser\u00E1 mostrada en la cuenta del usuario" })), _jsxs(Box, __assign({ sx: {
                    mt: 1,
                    p: 2,
                    border: "1px dashed #ccc",
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: '90%',
                    // height: 150,
                    cursor: "pointer",
                    boxSizing: "border-box",
                } }, { children: [logoData.logoUrl ? (_jsx("img", { src: logoData.logoUrl, alt: "Logo", style: { maxWidth: "100%", maxHeight: 80 } })) : (_jsx(CloudUploadIcon, { sx: { fontSize: 40 } })), _jsx("input", { type: "file", accept: ".svg" // Acepta solo archivos SVG
                        , onChange: handleFileChange, style: { display: "none" }, id: "upload-logo" }), _jsx(Typography, __assign({ variant: "caption", color: "textSecondary", sx: { mt: 1 } }, { children: "Solo se admite archivos SVG" })), _jsx("label", __assign({ htmlFor: "upload-logo" }, { children: _jsx(Button, __assign({ component: "span", color: "primary", sx: { mt: 1, textTransform: "none" } }, { children: "Cambiar logo" })) }))] }))] }));
}
